import { LocalStorage } from 'quasar'
import {
  localMockCardFlowToolsEnabled,
  MOCK_CARD_FLOW_STORAGE_KEY
} from '@/config/mockCardFlow'

export function readMockCardFlowEnabledFromStorage () {
  if (!localMockCardFlowToolsEnabled) {
    return false
  }
  const stored = LocalStorage.getItem(MOCK_CARD_FLOW_STORAGE_KEY)
  return stored === true || stored === 'true'
}

export function writeMockCardFlowEnabledToStorage (enabled) {
  if (!localMockCardFlowToolsEnabled) {
    return false
  }
  LocalStorage.set(MOCK_CARD_FLOW_STORAGE_KEY, Boolean(enabled))
  return true
}

export function isMockCardFlowActive () {
  return readMockCardFlowEnabledFromStorage()
}
